import { usePixelDrift } from '@/playback/AntiBurnIn';

export default function OfflineScreen() {
  const drift = usePixelDrift();
  return (
    <div style={{ ...styles.container, ...drift }}>
      <div style={styles.content}>
        <div style={styles.icon}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="1.5">
            <path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0112 21.95M5 12.55a10.94 10.94 0 015.17-7.39M10.71 5.05A16 16 0 0122.56 12.1M1.42 9A15.91 15.91 0 0110.71 5.05M8.53 16.11a6 6 0 016.95 0M12 20h.01" />
          </svg>
        </div>
        <h2 style={styles.title}>No Content Available</h2>
        <p style={styles.text}>
          Waiting for server connection to download campaign content.
          The player will start automatically once content is available.
        </p>
        <div style={styles.pulse} />
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    inset: 0,
    backgroundColor: '#0A0A0A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Inter, -apple-system, sans-serif',
  },
  content: {
    textAlign: 'center',
    maxWidth: 400,
  },
  icon: {
    marginBottom: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: '#888',
    margin: '0 0 12px 0',
  },
  text: {
    fontSize: 14,
    color: '#555',
    lineHeight: 1.6,
    margin: '0 0 32px 0',
  },
  pulse: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#FF6B2B',
    margin: '0 auto',
    animation: 'pulse 2s infinite',
  },
};
